module.exports = __webpack_public_path__ + "static/media/cal-medical-association-2.a8f0879f.jpg";